
import { RoutesMap } from '../types'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface IRestrictedRouteProps {
  pathRequired: RoutesMap
}

export const RestrictedRoute = (props: IRestrictedRouteProps) => {
    return (
        <Outlet />
    )
}